import { useEffect, useRef } from 'react';

import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';

export const useBodyScrollLock = (stopBodyScrolling: boolean) => {
  const targetRef = useRef(null);

  useEffect(() => {
    clearAllBodyScrollLocks();
    return clearAllBodyScrollLocks;
  }, []);

  useEffect(() => {
    if (stopBodyScrolling) {
      disableBodyScroll(targetRef.current);
    } else {
      enableBodyScroll(targetRef.current);
    }
  }, [stopBodyScrolling]);

  return targetRef;
};
